import React, { useState, useEffect } from "react";
import Tag from "../../../../generic/tag";
import "../../../../../assets/scss/components/toc/orderBook/instruments/instrumentsMob.scss";
import { ChipColorKeyComb, ChipStatusComb, scrlStCls, getMFCancelObj } from "../../obConstants";
import { IMF, IMFSip, IMFHold } from "../../../../types/components/orderBook/obTypes";
import { HOb2DGroupBy, HObGroupBy } from "../../../../service/orderBook/obGrpByHelper";
import indexer from "../../../../types/genericTypes";
import ObUtilHeader from "../../obContainer/obUtilHeader";
import DatePickerInt from "../../obContainer/obDatePickerInt";
import moment from "moment";
import dateTimeFormat from "../../../../service/dateTimeService";
import TocNoData from "../../../generic/tocNoData/tocNoData";
import { toINR } from "../../../../service/numberFormat";
import ObAssetDetailPopup from "../../generic/obAssetDetailPopup";
import ObMfDtlMob from "../../obDetails/mob/obMfDtlMob";
import ObMfSipDtlMob from "../../obDetails/mob/obMfSipDtlMob";
import { AMfCancelHoldTrd, AMfCancelNrmTrd } from "../../../../service/orderBook/obApiService";
import ee from "../../../../utils/eventEmitter";
import { SearchHighLight } from "../../../../service/generic/searchHighlight";

export interface IObMutualFundMobProps {
	data: Array<any>;
	//true if table is history type else false
	isHistory?: boolean;
	getDates: (frmDt: Date, toDate: Date) => void;
	isSip: boolean;
	hidePageNav?: (hide: boolean) => void;
	reRenderCall?: (value: string) => void;
}

const ObMutualFundMob: React.FC<IObMutualFundMobProps> = (props) => {
	// tableData data is shown in the table
	// tableData contains, sorted, filtered, searched data
	// wherever initial data needs to be sent, send initialData
	const initialData = [props.data.map((data: any, index: number) => ({ ...data, id: index }))];

	// tableData is shown in the table
	// tableData contains sorted, filtered, searched data
	let [tableData, setTableData] = useState(initialData);
	//holds executed order count ref
	const exeCountRef = React.useRef();
	//Show Open Ords on Top or not ref state
	const OpenOrdsTopRef = React.useRef<boolean>();
	let mfHistoryData: Array<{ [x: string]: Array<IMF> }> = [{}];
	useEffect(() => {
		setTableData([props.data]);
		//ref to initial toggle state of show open orders on top
		OpenOrdsTopRef.current = true;
		// check that props.data is not undefined/null, group it(open and others) and update tabledata

		if (props.data) {
			if (!props.isHistory && !props.isSip && OpenOrdsTopRef.current) {
				let temp0 = HOb2DGroupBy(props.data, "status", ["accepted"]);

				exeCountRef.current = temp0[1].length;
				setTableData(temp0);
			}
		}

		return () => {
			setTableData([[{}]]);
		};
	}, [props.data, props.isHistory, props.isSip]);
	//kept outside because state data updating in async mode

	if (props.isHistory) {
		mfHistoryData = tableData.map((group: any) => HObGroupBy(group, "txnDate", "T"));
	}

	// state for mf popup handling
	const [popupDataIndex, setPopupDataIndex] = React.useState<[number, number, string?]>();

	// this function excute on clicking any row
	function onRowClick(data: IMF | IMFSip, groupIndex: number, index: number) {
		setPopupDataIndex([groupIndex, index, props.isHistory ? (data as IMF).txnDate.split("T")[0] : undefined]);
	}

	const MfTxnType: indexer = {
		FP: "Fresh Purchase",
		AP: "Add. Purchase",
		R: "Reedem",
		XSIP: "XSIP"
	};

	function onDataFilter(data: Array<any>, sText: string = "", type?: string) {
		//highlightes the search text
		if (sText) {
			const SearchText: string = sText.toLowerCase();
			data[0].map((ord: IMF) => {
				ord.schemeName = SearchHighLight(ord.schemeName, SearchText);
				return true;
			});
		}

		if (type === "search" && OpenOrdsTopRef.current && !props.isHistory) {
			setTableData(HOb2DGroupBy(data[0], "status"));
		} else {
			setTableData(data);
		}
	}

	let ordCancelledSuccList: Array<string> = [],
		ordCancelledFailList: Array<string> = [],
		ordsListToCancel: Array<string> = [];

	// runs after all cancel api response
	function cancelCallback(res: any) {
		if (res.data) {
			// if success
			ordCancelledSuccList.push(res.data);
		} else {
			// if error
			ordCancelledFailList.push(res.error);
		}

		// when we get all the responses
		if (ordCancelledSuccList.length + ordCancelledFailList.length === ordsListToCancel.length) {
			//show toast message
			ee.emit("showToast", { message: `Cancelled ${ordsListToCancel.length} Orders`, color: "cancell" });
			props.reRenderCall && props.reRenderCall("today");
		}
	}

	function cancelOrder(data: IMF | IMFSip | IMFHold) {
		ordsListToCancel.push(data.txnID);

		if (data.status.toLowerCase() === "on hold") {
			AMfCancelHoldTrd(cancelCallback, getMFCancelObj(data));
		} else {
			AMfCancelNrmTrd(cancelCallback, getMFCancelObj(data));
		}
	}

	function mfRow(item: IMF, groupIndex: number, index: number) {
		return (
			<div className="mf_mob new_offers_mob_con" key={index} onClick={(e) => onRowClick(item, groupIndex, index)}>
				<div className="tag">
					<Tag
						value={item.txnType === "R" ? "S" : "B"}
						shape="mini_circle"
						color={item.txnType === "R" ? "red" : "green"}
						height="22px"
						width="22px"
					/>
				</div>
				<div className="new_offers_data">
					<div className="date">{item.txnTime}</div>
					<div className="comp_con">
						<div className="sym">
							<span dangerouslySetInnerHTML={{ __html: item.schemeName }}></span>
						</div>
						<div className="sts">
							<Tag value={ChipStatusComb[item.status.toLowerCase()]} color={ChipColorKeyComb[item.status.toLowerCase()]} />
						</div>
					</div>
					<div className="new_offers_values">
						<div className="prod_value">{MfTxnType[item.txnType]}</div>
						<div className="amt">{item.amount !== "0" ? "₹" + toINR(item.amount, 2) : item.units}</div>
					</div>
				</div>
			</div>
		);
	}
	function nonSip() {
		return (
			<>
				<div className="eq_wrap_mob">
					{props.isHistory || props.isSip ? (
						mfHistoryData.map((group: any, groupIndex: number) =>
							Object.keys(group).map((date: any, index) => {
								return (
									<React.Fragment key={index}>
										<ul className={scrlStCls.freeze + " eq_hist_date hist_date"} key={"dtGp" + index}>
											<li>{moment(dateTimeFormat(date)).format("DD MMMM YYYY")}</li>
										</ul>
										<ul className={scrlStCls.toContext} key={"dtUlDet" + index}>
											{group[date].map((row: any, index: number) => (
												<React.Fragment key={index}>{mfRow(row, groupIndex, index)}</React.Fragment>
											))}
										</ul>
									</React.Fragment>
								);
							})
						)
					) : (
						<>
							{
								!!tableData.length &&
									tableData.map((group: any, groupIndex: number) =>
										// Object.keys(group).map((grp: any, index) =>
										{
											return (
												<React.Fragment key={groupIndex}>
													{group.length > 0 && (
														<ul key={groupIndex} className={"blockDivider child" + groupIndex}>
															{/* {tableData.map((group, groupIndex) => */}
															{group.map((row: any, index: number) => (
																<React.Fragment key={index}>{mfRow(row, groupIndex, index)}</React.Fragment>
															))}
															{/* )} */}
														</ul>
													)}
												</React.Fragment>
											);
										}
									)
								// )
							}
							{!tableData.length && <TocNoData data={initialData} callBackMeth={onDataFilter} />}
						</>
					)}
				</div>
			</>
		);
	}

	function sipOrders() {
		return (
			<>
				{!!tableData.length &&
					tableData.map((group: any, groupIndex: number) =>
						// Object.keys(group).map((grp: any, index) =>
						{
							return (
								<div key={groupIndex}>
									{group.map((item: IMFSip, index: number) => (
										<div className="sip_mob_con" key={index} onClick={(e) => onRowClick(item, groupIndex, index)}>
											<div className="tag">
												<Tag value="B" shape="mini_circle" color="green" height="30px" width="30px" />
											</div>
											<div className="sip_data_con">
												<div className="date">
													Next:
													<span className="dte">{moment(dateTimeFormat(item.nextDueDate)).format("DD MMM ’YY")}</span>
												</div>
												<div className="comp_con">
													<div className="comp">
														<span dangerouslySetInnerHTML={{ __html: item.schemeName }}></span>
													</div>
													<div className="sts">
														<Tag
															value={ChipStatusComb[item.status.toLowerCase()]}
															color={ChipColorKeyComb[item.status.toLowerCase()]}
														/>
													</div>
												</div>
												<div className="sip_values">
													<div className="lft_val">
														<span className="tCC">
															{item.frequency.toLowerCase()} (
															{item.status.toLowerCase() === "running"
																? parseInt(item.totalInstalments) - parseInt(item.instalmentsPending)
																: 0}
															/{item.totalInstalments})
														</span>
														<span className="amt_qty">
															<span>{item.units ? item.units : "--"} </span>Qty
														</span>
													</div>
													<div className="rgt_val">{item.amount ? "₹" + toINR(item.amount, 0) : "--"}</div>
												</div>
											</div>
										</div>
									))}
								</div>
							);
							// )
						}
					)}
				{!tableData.length && <TocNoData data={initialData} callBackMeth={onDataFilter} />}
			</>
		);
	}
	return (
		<div className="instMobView eq_wrap_mob">
			<ObUtilHeader
				leftSideText={
					!props.isHistory && !props.isSip ? (
						<div className="executed">
							<span className="text">{props.isSip ? "Active SIPs" : "Executed Orders"}: </span>
							<span className="value">
								{!props.isSip
									? exeCountRef.current + " /" + initialData[0].length
									: tableData[0].filter((row: IMFSip) => row.status.toLowerCase() === "running").length}
							</span>
						</div>
					) : props.isHistory ? (
						<DatePickerInt plusDays={15} sendDates={props.getDates} />
					) : (
						<></>
					)
				}
				data={initialData}
				searchKey="cpName;dpName;trdSym"
				onDataFilter={onDataFilter}
				onSelectClick={undefined}
				onFilterClick={(tgl) => {
					OpenOrdsTopRef.current = tgl;
				}}
				filterReqData={{
					status: "status",
					aType: props.isSip ? "mfSip" : "mf",
					showOpenOrderOnTop: OpenOrdsTopRef.current,
					showOpenOrderTgl: props.isHistory ? false : true,
					isHistory: props.isHistory ? true : false
				}}
				onSearchClick={(e) => {
					setTableData(initialData);
					// if exists, then call it
					props.hidePageNav && props.hidePageNav(e);
				}}
			/>
			{!props.isSip && nonSip()}
			{props.isSip && sipOrders()}
			{/* tableData[groupIndex][index] */}
			{popupDataIndex && (
				<ObAssetDetailPopup>
					{props.isSip ? (
						<ObMfSipDtlMob
							data={tableData[popupDataIndex[0]][popupDataIndex[1]]}
							onBackClick={() => setPopupDataIndex(undefined)}
							onCancelClick={() => cancelOrder(tableData[popupDataIndex[0]][popupDataIndex[1]])}
						/>
					) : (
						<ObMfDtlMob
							data={
								props.isHistory
									? mfHistoryData[popupDataIndex[0]][popupDataIndex[2]!][popupDataIndex[1]]
									: tableData[popupDataIndex[0]][popupDataIndex[1]]
							}
							onBackClick={() => setPopupDataIndex(undefined)}
							onCancelClick={() => cancelOrder(tableData[popupDataIndex[0]][popupDataIndex[1]])}
						/>
					)}
				</ObAssetDetailPopup>
			)}
		</div>
	);
};

export default ObMutualFundMob;
